var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPortfolio105 = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 105,
  height: 105,
  viewBox: "0 0 105 105",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9 26.5C9 24.5661 10.5661 23 12.5 23H92.5C94.4339 23 96 24.5661 96 26.5V66H62.5C62.2239 66 62 66.2239 62 66.5C62 66.7761 62.2239 67 62.5 67H96.5C96.7761 67 97 66.7761 97 66.5V26.5C97 24.0139 94.9861 22 92.5 22H12.5C10.0139 22 8 24.0139 8 26.5V66.5C8 66.7761 8.22386 67 8.5 67H42.5C42.7761 67 43 66.7761 43 66.5C43 66.2239 42.7761 66 42.5 66H9V26.5ZM13 76.5C13 76.2239 12.7761 76 12.5 76C12.2239 76 12 76.2239 12 76.5V90.5C12 92.9861 14.0139 95 16.5 95H88.5C90.9861 95 93 92.9861 93 90.5V76.5C93 76.2239 92.7761 76 92.5 76C92.2239 76 92 76.2239 92 76.5V90.5C92 92.4339 90.4339 94 88.5 94H16.5C14.5661 94 13 92.4339 13 90.5V76.5Z",
  fill: "currentColor"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M38.5 10C38.2239 10 38 10.2239 38 10.5V22.5C38 22.7761 38.2239 23 38.5 23C38.7761 23 39 22.7761 39 22.5V11H66V22.5C66 22.7761 66.2239 23 66.5 23C66.7761 23 67 22.7761 67 22.5V10.5C67 10.2239 66.7761 10 66.5 10H38.5ZM42.5 58C42.2239 58 42 58.2239 42 58.5V74.5C42 74.7761 42.2239 75 42.5 75H62.5C62.7761 75 63 74.7761 63 74.5V58.5C63 58.2239 62.7761 58 62.5 58H42.5ZM43 74V59H62V74H43Z",
  fill: "var(--icon-decorative-coral)"
})));
export default SvgPortfolio105;